import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

import { setUserSession } from './service/AuthService';

import './css/Login-Register.css';
import logoBold from './assets/logoBold.png';
import { MaterialResetPassword, MaterialPassword } from './MaterialComponents';


//TODO: move this to an environment variable
const resetPasswordtUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/resetpass';
const loadingSpinner = document.querySelector('.donut');


const SetNewPassword = () => {
    const [passwordTwo, setPasswordTwo] = useState('');
    const [password, setPassword] = useState('');
    const [token, setToken] = useState('');
    const location = useLocation();

    //Learning Form Data (move it here)
    function handlePasswordTwoState(newValue) {
        setPasswordTwo(newValue);
    }
    function handlePasswordState(newValue) {
        setPassword(newValue);
    }

    const [message, setMessage] = useState('');
    const [isShown, setIsSHown] = useState(false);


    const navigate = useNavigate()

    const loginHandler = () => {
        //console.log('lets register woooo')
        // navigate('/register');
        navigate('/login');
    }

    const submitHandler = (event) => {
        event.preventDefault();
        const errors = [];

        if (password.trim() === "") {
            errors.push("Please enter a new password.");
        }
        
        if (password.length > 0 && password.length < 8) {
            errors.push("Password must be at least 8 characters.");
        }
        
        if (password !== passwordTwo) {
            errors.push("Passwords do not match.");
        }
        
        if (errors.length > 0) {
            setMessage(errors.join(" "));
            return;
        }

        setMessage(null)
        setMessage('Resetting Password...')
        
        //TODO: move this to an environment variable
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        const requestBody = {
            token: token,
            password: password
        }

        console.log(requestBody)

        axios.post(resetPasswordtUrl, requestBody, requestConfig).then(response => {
            // setUserSession(response.data.user, response.data.token);
            // //console.log('login data response')
            //console.log(response.data.user)
            // //console.log(response.data.user.onboardingComplete)
            // //TODO: fix bug -- update always shows up
            // if(!response.data.user.onboardingComplete){
            //     navigate('/onboarding-demo');
            // }
            // else{
            //     document.querySelector('.header').style.display = 'block'
            //     navigate('/daily-content'); 
            // }
            setMessage(response.data.message)
            
        }).catch(error => {
            //TODO: fix error of receiving null error
            if(error.response.status === 400 || error.response.status === 401 || error.response.status === 403 ){
                setMessage(error.response.data.message);
            }
            else{
                setMessage('Sorry the server is down. Please try again later.');

            }
        })
    }

    useEffect(() => {
        document.querySelector('.header').style.display = 'none'
        if (loadingSpinner) {
            //console.log('deleting donute')
            loadingSpinner.style.display = 'none'; // Example: Change the text color
        }

        const params = new URLSearchParams(location.search);
        const resetToken = params.get("token");
        if (resetToken) {
            setToken(resetToken);
            console.log('here is the reset token: ', resetToken)
        } else {
            setMessage("Link expired. Request a new password reset link.");
        }
    }, [location]);

    return (
        <div style={{ marginLeft: '2rem', marginRight: '2rem', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', marginBottom: '2rem'}}> 
            <div className="logo" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '1rem', paddingTop: '5rem'}}>
                <img style={{ width: '95%', maxWidth: '415px', marginBottom: '1rem' }} src={logoBold} alt="Example" />
            </div>
            <form onSubmit = { submitHandler }>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                    <h4 className="form-title" style={{ textAlign: 'center' }}>Create new password</h4>
                    <p className="form-title" style={{ textAlign: 'center', maxWidth: '320px' }}>Your new password must be different from previous passwords.</p>

                    <div className="relapseQuestion">password:</div>
                    <MaterialResetPassword handleChange={handlePasswordTwoState}/>
                    <div className="relapseQuestion">confirm password:</div>
                    <MaterialPassword handleChange={handlePasswordState} />
                    {message && <p className="message"> { message } </p>}
                    <button type="submit" className="homeBttn" style={{ marginTop: '3rem', width: '310px' }}>Reset Password</button>
                    <button className="homeBttn" style={{ marginTop: '1.5rem', width: '310px' }} onClick={loginHandler}>Go To Login</button>

                    {/* <MateriaBasicTextField type={isShown ? "text" : "password"} handleChange={handlePasswordState} /> */}
                    {/* username: <input type="text" value={username} onChange={event => setUsername(event.target.value)} /> <br /> */}
                    {/* password: <input type={isShown ? "text" : "password"} className="input" value={password} onChange={event => setPassword(event.target.value)} /> <br /> */}
                    {/* <input style={{ marginTop: '2rem' }} className="submit-bttn" type="submit" value="Login" />
                    {message && <p className="message"> { message } </p>}
                    <button type="submit" className="homeBttn" style={{ marginTop: '3rem', width: '310px' }}>Reset Password</button>
                    {/* <button className="homeBttn" style={{ marginTop: '1.5rem', width: '310px' }} onClick={registerHandler}>Register</button> */}
                </div>
            </form>
            {/* <button className="homeBttn" style={{ marginTop: '1.5rem', width: '310px', marginBottom: '1rem' }} onClick={registerHandler}>Register</button> */}

            {/* <div className="button-container-login-register">
                <button className="login button-login-register">Login</button>
                <button className="register button-login-register" onClick={registerHandler}>Register</button>
            </div> */}
        </div>
    )
}


export default SetNewPassword;